import { IExportColumnModel } from "../../../../../shared/models";

export const InboundEmailAddressesExportColumnList: IExportColumnModel[] = [
]